import {
  cancelForAnyReason,
  checkInBaggage,
  climateCompensation,
  flexibleTicket,
} from '@eti/products';
import sumBy from 'lodash/sumBy';
import type {
  SellSpecificationBaggageNew,
  SellSpecificationNoneNew,
  SellSpecificationTravelerNew,
} from '@eti/schema-types';
import type { AvailableExtraProductsType } from '../v3/branded-fares/model';

export const getIncludedProductPrice = (
  availableExtraProducts: AvailableExtraProductsType[],
  selectedExtraProducts: number[],
) => {
  return selectedExtraProducts.reduce((totalPrice: number, id: number) => {
    const selectedProduct = availableExtraProducts.find(
      (product) => product.productId === String(id),
    );
    const sellSpecification = selectedProduct?.sellSpecification;
    let productTotalprice = 0;

    if (sellSpecification) {
      if (id === flexibleTicket.id) {
        const sellSpecificationTravelers = sellSpecification as SellSpecificationTravelerNew;
        const flexibleTicketPrices = sellSpecificationTravelers?.sellPriceTravelers;
        productTotalprice = sumBy(flexibleTicketPrices, 'price.price.value');
      } else if (id === checkInBaggage.id) {
        const sellSpecificationBaggage = sellSpecification as SellSpecificationBaggageNew;
        const checkInBaggageSellPriceBaggage = sellSpecificationBaggage?.sellPriceBaggage;
        productTotalprice = sumBy(checkInBaggageSellPriceBaggage, 'price.price.value');
      } else if (id === cancelForAnyReason.id) {
        const cfarTicketSellSpecification = sellSpecification;
        productTotalprice = sumBy([cfarTicketSellSpecification], 'price.price.value');
      } else if (id === climateCompensation.id) {
        const climateCompensationSellSpecification = sellSpecification as SellSpecificationNoneNew;
        productTotalprice = sumBy([climateCompensationSellSpecification], 'price.price.value');
      }
    }

    return totalPrice + productTotalprice;
  }, 0);
};
